function getDifferentArray(oldArray, newArray) {
    const isEqual = (arr1, arr2) => {
        if (arr1?.length !== arr2?.length) {
            return false;
        }

        for (let i = 0; i < arr1?.length; i++) {
            const obj1 = arr1[i];
            const obj2 = arr2[i];
            const obj1Keys = Object.keys(obj1);
            const obj2Keys = Object.keys(obj2);

            if (obj1Keys?.length !== obj2Keys?.length) {
                return false;
            }

            for (let j = 0; j < obj1Keys?.length; j++) {
                const key = obj1Keys[j];

                if (obj1[key] !== obj2[key]) {
                    return false;
                }
            }
        }

        return true;
    };

    if (!isEqual(oldArray, newArray)) {
        return newArray;
    }
}

const changedForm = (initialValue, newData) => {
    const changedFields = {};
    for (const [key, value] of Object.entries(newData)) {
        if (
            value !== initialValue[key] &&
            (typeof value === "string" || typeof value === "number")
        ) {
            changedFields[key] = value;
        }
        if (value?.value !== initialValue[key]?.value && typeof value === "object") {
            changedFields[key] = value;
        }
        if (Array.isArray(value)) {
            const comparingResult = getDifferentArray(initialValue[key], value);
            if (comparingResult) {
                changedFields[key] = comparingResult;
            }
        }
    }
    return changedFields;
};

export default changedForm;
